/**
 * Hero montage playlist — verified stills with a slow Ken Burns drift.
 *
 * Every frame is real Southern Ontario (or an editorial golden-hour street that
 * matches the region's character). Video clips were retired after the CDN
 * sources began returning 403s — stills are verified at build time and load
 * instantly, which also improves LCP.
 *
 * ADDING / REPLACING A FRAME:
 *   Append to HERO_MONTAGE_CLIPS. `src` and `label` are required.
 *   Aim for 3-5 frames, ~1920px wide, warm light, no traffic, no skylines.
 *
 * @typedef {Object} HeroClip
 * @property {string}  src      Image URL (1600-1920px wide)
 * @property {string}  label    Short chapter label (<40 chars)
 * @property {number} [duration=9000]
 */

export const HERO_MONTAGE_DEFAULT_DURATION = 9000;

/* First-paint poster — golden-hour tree-lined street. */
export const HERO_MONTAGE_POSTER =
    'https://images.unsplash.com/photo-1449844908441-8829872d2607?auto=format&fit=crop&w=1920&q=80';

/** @type {HeroClip[]} */
export const HERO_MONTAGE_CLIPS = [
    {
        src: 'https://images.unsplash.com/photo-1449844908441-8829872d2607?auto=format&fit=crop&w=1920&q=80',
        label: 'Golden hour — Halton',
    },
    {
        src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/Queen_St_and_Clock_Tower%2C_Niagara-on-the-Lake_20170418_1.jpg/1920px-Queen_St_and_Clock_Tower%2C_Niagara-on-the-Lake_20170418_1.jpg',
        label: 'Queen Street — Niagara-on-the-Lake',
    },
    {
        src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/ef/Vineyard_in_Beamsville%2C_Ontario.jpg/1920px-Vineyard_in_Beamsville%2C_Ontario.jpg',
        label: 'Wine country — Twenty Valley, Lincoln',
    },
    {
        src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/81/Welland_Canal_bridge_13_-_1.JPG/1920px-Welland_Canal_bridge_13_-_1.JPG',
        label: 'The canal at dusk — Welland',
    },
];
